import React from 'react';
import './Banar.css'
import { Carousel } from 'react-bootstrap';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


const Banar = () => {
     const banarHandle = () => toast('Thanks For Click Me !')
     return (
          <div className='banar'>
               <Carousel>
                    <Carousel.Item interval={1000}>
                         <img style={{ height: '600px' }}
                              className="photo d-block  w-100"
                              src="https://etimg.etb2bimg.com/thumb/etauto-original-luxury-vehicles-delivering-unique-customer-experience-through-human-centered-approach-size-110282/84161541.cms?width=1000&height=480"
                              alt="First slide"
                         />
                         <Carousel.Caption className='d-none d-sm-block'>


                              <h1>Welcome To Our Website</h1>
                              <p>If you are looking for a good car then you are at the right place, you can see the car <br></br> of your choice and send it to us, we will deliver  it to your house, <br></br> so buy the car of your choice without delay.</p>
                              <button onClick={banarHandle} className='btn btn-primary p-2 mb-5'>ORDER US NOW 🡲</button>


                         </Carousel.Caption>
                    </Carousel.Item>
                    <Carousel.Item interval={500}>
                         <img style={{ height: '600px' }}
                              className="d-block img-fluid w-100"
                              src="https://www.topgear.com/sites/default/files/news-listicle/image/row09068.jpg?w=827&h=465"
                              alt="Second slide"
                         />
                         <Carousel.Caption className='d-none d-sm-block'>
                              <h1>Welcome To Our Website</h1>
                              <p>If you are looking for a good car then you are at the right place, you can see the car <br></br> of your choice and send it to us, we will deliver  it to your house, <br></br> so buy the car of your choice without delay.</p>
                              <button onClick={banarHandle} className='btn btn-primary p-2 mb-5'>ORDER US NOW 🡲</button>
                         </Carousel.Caption>
                    </Carousel.Item>
                    <Carousel.Item>
                         <img style={{ height: '600px' }}
                              className="d-block img-fluid  w-100"
                              src="https://www.topgear.com/sites/default/files/news-listicle/image/rr_swb_phev_006.jpg?w=827&h=465"
                              alt="Third slide"
                         />
                         <Carousel.Caption className='d-none d-sm-block'>
                              <h1>Welcome To Our Website</h1>
                              <p>If you are looking for a good car then you are at the right place, you can see the car <br></br> of your choice and send it to us, we will deliver  it to your house, <br></br> so buy the car of your choice without delay.</p>
                              <button onClick={banarHandle} className='btn btn-primary p-2 mb-5'>ORDER US NOW 🡲</button>
                         </Carousel.Caption>
                    </Carousel.Item>
               </Carousel>
               <ToastContainer></ToastContainer>
          </div>
     );
};

export default Banar;